import config from './config';
import methods from './methods';
import store from './store';

export { activeFilterCount } from './store';

export default {
	config,
	...methods,
	...store
};
